import { VAvatar } from '@/index/shared/components';
import UiProfileAvatarList from './avatar-list.vue';

export default {
  components: {
    VAvatar,
    UiProfileAvatarList,
  },
  data() {
    return {
      avatarEdit: false,
    };
  },
  methods: {
    editAvatar() {
      this.avatarEdit = true;
    },
    changeAvatar(avatar) {
      this.avatarEdit = false;
      this.profile.avatar = avatar || {};
    },
  },
};
